import axios from "axios";
import { useEffect, useState } from "react";
import { CategoryParents, Get_SubjectCategory_ID_Children } from "../api/api";


const useCategoryList = (refresh = true, setRefresh) => {

     const [parentCats, setParentCats] = useState([]);
     const [parentAndChildren, setParentAndChildren] = useState(null);

     useEffect(() => {
          const getParents = async () => {
               try {
                    const res = await axios.get(CategoryParents);
                    setParentCats(res.data)
               } catch (error) {

               }
          }
          getParents()
     }, [refresh === true]);

     const dataHolder = []

     useEffect(() => {
          const getChildren = async () => {

               for (let i = 0; i < parentCats.length; i++) {

                    try {
                         const res = await axios.get(Get_SubjectCategory_ID_Children(parentCats[i].id));

                         let obj = {
                              id: parentCats[i].id,
                              parentId: parentCats[i].parentId,
                              title: parentCats[i].title,
                              child: res.data
                         }
                         dataHolder.push(obj)


                    } finally {
                         setRefresh && setRefresh(false)
                    }
               }
               setParentAndChildren(dataHolder);
          }
          getChildren()

     }, [parentCats]);



     return parentAndChildren != '' ? parentAndChildren : false
}

export default useCategoryList